import { motion } from "framer-motion";
import { PROFILE } from "../data";

const HERO_PHOTO =
  "https://customer-assets.emergentagent.com/job_soul-journey-3d/artifacts/3v1h62hc_Gemini_Generated_Image_9fx3y19fx3y19fx3%20%282%29.png";
const HERO_PHOTO_MOBILE =
  "https://customer-assets.emergentagent.com/job_soul-journey-3d/artifacts/kgh6437a_FC5F8442-9C8B-4152-89D6-2ABB6CBC7169_1_102_o.jpeg";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1, delay: i * 0.18, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Hero = () => {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header
      data-testid="hero-section"
      className="relative min-h-[100svh] md:min-h-screen overflow-hidden"
    >
      {/* fotografie + overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_PHOTO_MOBILE}
          alt="Ovidiu"
          data-testid="hero-photo"
          fetchPriority="high"
          decoding="async"
          className="hidden md:block w-full h-full object-cover object-center"
          style={{ filter: "contrast(1.08) saturate(1.06) brightness(1.07)" }}
        />
        <img
          src={HERO_PHOTO_MOBILE}
          alt="Ovidiu"
          data-testid="hero-photo-mobile"
          fetchPriority="high"
          decoding="async"
          className="block md:hidden w-full h-full object-cover object-[42%_center]"
          style={{ filter: "contrast(1.06) saturate(1.05) brightness(1.05)" }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(5,7,15,0.62) 0%, rgba(5,7,15,0.28) 26%, rgba(5,7,15,0.28) 52%, rgba(5,7,15,0.82) 86%, rgba(5,7,15,1) 100%)",
          }}
        />
        <div
          className="absolute inset-0 md:hidden"
          style={{
            background: "rgba(5,7,15,0.28)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(circle at 50% 44%, rgba(5,7,15,0) 0%, rgba(5,7,15,0.2) 70%, rgba(5,7,15,0.5) 100%)",
          }}
        />
        <div
          className="absolute inset-0 mix-blend-overlay opacity-50"
          style={{
            background:
              "radial-gradient(circle at 50% 38%, rgba(38,104,222,0.4), transparent 60%)",
          }}
        />
      </div>

      {/* continut */}
      <div className="relative z-10 min-h-[100svh] md:min-h-screen flex flex-col items-center text-center px-6 justify-between pt-60 md:pt-32 pb-28 md:pb-32">
        <div className="flex flex-col items-center">
        <motion.p
          custom={0}
          initial="hidden"
          animate="show"
          variants={reveal}
          className="hero-readable text-outline-soft text-[11px] md:text-xs font-bold uppercase tracking-[0.4em] text-[#D6B56D] mb-4 md:mb-8"
        >
          {PROFILE.tagline}
        </motion.p>

        <motion.h1
          custom={1}
          initial="hidden"
          animate="show"
          variants={reveal}
          className="hero-title-shadow text-outline-soft font-heading font-light text-[#EBE4D8] leading-[0.95] text-5xl sm:text-6xl md:text-8xl lg:text-[9rem] break-words max-w-full"
        >
          I am <span className="italic text-[#D6B56D]">{PROFILE.firstName}…</span>
        </motion.h1>
        </div>

        <div className="flex flex-col items-center">
        <motion.p
          custom={2}
          initial="hidden"
          animate="show"
          variants={reveal}
          className="hero-readable mt-8 max-w-xl text-base md:text-lg text-[#EBE4D8]/90 leading-relaxed font-light"
        >
          I live for experiences. I search for meaning in faraway places and in
          the silence between breaths. This is the map of my soul.
        </motion.p>

        <motion.div
          custom={3}
          initial="hidden"
          animate="show"
          variants={reveal}
          className="mt-12 flex flex-col sm:flex-row gap-4"
        >
          <button
            data-testid="hero-cta-story"
            onClick={() => scrollTo("povestea-mea")}
            className="px-9 py-3.5 rounded-full border border-[#EBE4D8]/70 text-[#EBE4D8] text-sm tracking-widest uppercase hover:border-[#D6B56D] transition-colors duration-300"
          >
            My Story
          </button>
        </motion.div>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 1 }}
        className="hidden md:flex absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-3 text-[#EBE4D8]/70"
      >
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <span className="w-px h-12 gold-line animate-floaty" />
      </motion.div>
    </header>
  );
};
